module.exports = __webpack_public_path__ + "static/S_hero-qrcode.tw-fc940a568b22c306b910bff3b9ee1fa4.png";